import { Flex, HStack, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import apiClient from '../../../../canopy-ui-components/api';
import FileName from '../../../../canopy-ui-components/components/CanopyTable/Cells/FileName';
import ErrorBox from '../../../../canopy-ui-components/components/ErrorBox/ErrorBox';
import Tags from '../../../../canopy-ui-components/components/Tags/Tags';
import { useCurrentColors } from '../../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import DeleteFileAction from '../actions/DeleteFileAction';
import DownloadFileAction from '../actions/DownloadFileAction';
import ManageFileTagsAction from '../actions/EditFileDetailsAction';
import ViewDocumentsSkeleton from './ViewDocumentsSkeleton';
function ViewDocuments({ tagValue, userId, globalProps, refreshData }: any) {
    const { t } = globalProps;
    const [documents, setDocuments] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const currentColors = useCurrentColors();
    useEffect(() => {
        (async () => {
            if (tagValue && userId) {
                setLoading(true);
                setError('');
                const queryParams = {
                    tag_value: tagValue,
                    parent_user_ids: userId,
                };
                userId === 'all' && delete queryParams.parent_user_ids;
                try {
                    const { data }: any =
                        (await apiClient?.get('documents', {
                            queryParams,
                        })) || {};
                    if (!data?.error) {
                        setDocuments(data?.documents);
                    } else {
                        setError(data?.error);
                        setDocuments([]);
                    }
                    setLoading(false);
                } catch (e: any) {
                    setError(
                        e?.response?.data?.error || e?.response?.data?.message
                    );
                    setLoading(false);
                }
            }
        })();
    }, [tagValue, userId]);

    if (loading) {
        return <ViewDocumentsSkeleton></ViewDocumentsSkeleton>;
    }

    if (error) {
        return (
            <ErrorBox
                position="relative"
                height="100%"
                error={error}
            />
        );
    }

    if (documents?.length === 0) {
        return (
            <ErrorBox
                position="relative"
                height="100%"
                error={t('no-data-available')}
            />
        );
    }
    return (
        <VStack
            spacing="15px"
            width="100%">
            {documents?.map((document) => {
                const tags = [
                    ...(document?.transactionTagValue?.map(
                        (tag: any) => tag.tagValue
                    ) || []),
                    ...(document?.securityTagValue?.map(
                        (tag: any) => tag.tagValue
                    ) || []),
                    ...(document?.customTagValue?.map(
                        (tag: any) => tag.tagValue
                    ) || []),
                ];
                return (
                    <>
                        <Flex
                            width="100%"
                            justifyContent="space-between">
                            <Flex
                                minWidth="calc(100% - 64px)"
                                width="calc(100% - 64px)">
                                <FileName
                                    row={document}
                                    dataKey={'fileName'}></FileName>
                            </Flex>
                            <HStack spacing="2px">
                                <DownloadFileAction
                                    refreshData={refreshData}
                                    globalProps={globalProps}
                                    data={[{ ...document }]}
                                    userId={userId}></DownloadFileAction>
                                <ManageFileTagsAction
                                    refreshData={refreshData}
                                    globalProps={globalProps}
                                    data={[{ ...document }]}
                                    userId={userId}></ManageFileTagsAction>
                                <DeleteFileAction
                                    refreshData={refreshData}
                                    globalProps={globalProps}
                                    data={[{ ...document }]}
                                    userId={userId}></DeleteFileAction>
                            </HStack>
                        </Flex>
                        <Tags
                            display="block"
                            tagHeight="20px"
                            width="100%"
                            height="auto"
                            flexDirection="column"
                            items={tags}
                            onClick={() => {}}
                            isDisabled={true}
                            globalProps={globalProps}
                            selected=""></Tags>
                    </>
                );
            })}
        </VStack>
    );
}

export default ViewDocuments;
